import { TAB_NAME_TRANSFORMATIONS, TAB_TITLE_VARIATIONS, TAB_CATEGORY_NAME_MAP } from '../../constants/tabs';

const prepareCategoryName = (name) => {
  // Regex seamlessly removes "All " from the beginning, case-insensitive
  const cleanName = name.replace(/^All\s+/i, '');
  return TAB_CATEGORY_NAME_MAP[cleanName] || cleanName;
};

const formatTabName = (variation, tabName) => {
  return variation
    .replace(TAB_NAME_TRANSFORMATIONS.original, tabName)
    .replace(TAB_NAME_TRANSFORMATIONS.lowercased, tabName.toLowerCase())
    .replace(TAB_NAME_TRANSFORMATIONS.capitalized, tabName.charAt(0).toUpperCase() + tabName.slice(1).toLowerCase());
};

export const getFullTabTitle = ({ tabName, type, index, userStatus, brand }) => {
  const variations = TAB_TITLE_VARIATIONS[brand][type][userStatus];
  const selectedVariation = variations[index % variations.length];

  const preparedTabName = type === 'category' ? prepareCategoryName(tabName) : tabName;

  return formatTabName(selectedVariation, preparedTabName);
};
